(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
  const accordions = document.querySelectorAll(".accordion details");

  accordions.forEach((accordion) => {
    accordion.addEventListener("toggle", function() {
      if (accordion.open) {
        accordions.forEach((other) => {
          if (other !== accordion && other.open) {
            other.open = false;
          }
        });
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
